import React, { Component } from 'react';

import './Contact.css';
import mailIcon from '../../icons/ic_mail.svg';
import twitterIcon from '../../icons/ic_twitter.svg';
import githubIcon from '../../icons/ic_github.svg';
import userReportIcon from '../../icons/ic_user_report.svg';
import { trackHostClick } from '../../utils';

class Contact extends Component {
  render() {
    return (
      <div
        className="lp-desktop-contact-container"
        style={{
          height: this.props.height,
        }}
      >
        <div className="lp-desktop-contact-core">
          <div className="lp-desktop-contact-core-first-row">
            <div className="lp-social-media">
              <a href="mailto:geo.improveosm@grabtaxi.com" target="_blank" rel="noopener noreferrer" onClick={e => {
                trackHostClick(e, 'a social media icon from the desktop contact');
              }}>
                <div>
                  <img width="32" height="32" src={mailIcon} alt="Email Us Icon"/>
                  <label>Email Us</label>
                </div>
              </a>
              <a href="https://twitter.com/improveosm" target="_blank" rel="noopener noreferrer" onClick={e => {
                trackHostClick(e, 'a social media icon from the desktop contact');
              }}>
                <div>
                  <img width="32" height="32" src={twitterIcon} alt="Twitter Icon"/>
                  <label>Twitter</label>
                </div>
              </a>
              <a href="https://github.com/ImproveOSM/geohash-plugin" target="_blank" rel="noopener noreferrer" onClick={e => {
                trackHostClick(e, 'a social media icon from the desktop contact');
              }}>
                <div>
                  <img width="32" height="32" src={githubIcon} alt="Github Icon"/>
                  <label>Github Geohash Plugin</label>
                </div>
              </a>
              <a href="https://github.com/kartaview/josm-plugin" target="_blank" rel="noopener noreferrer" onClick={e => {
                 trackHostClick(e, 'a social media icon from the desktop contact');
              }}>
                 <div>
                   <img width="32" height="32" src={githubIcon} alt="Github Icon"/>
                   <label>Github KartaView</label>
                 </div>
              </a>
              <a href="https://github.com/ImproveOSM/geohash-plugin/issues" target="_blank" rel="noopener noreferrer" onClick={e => {
                trackHostClick(e, 'a social media icon from the desktop contact');
              }}>
                <div>
                  <img width="32" height="32" src={userReportIcon} alt="User Report Icon"/>
                  <label>Geohash Plugin</label>
                </div>
              </a>
              <a href="https://github.com/kartaview/josm-plugin/issues" target="_blank" rel="noopener noreferrer" onClick={e => {
                trackHostClick(e, 'a social media icon from the desktop contact');
              }}>
                <div>
                  <img width="32" height="32" src={userReportIcon} alt="User Report Icon"/>
                  <label>KartaView</label>
                </div>
              </a>
            </div>
            <div className="lp-copyright">
              Copyright © 2024 Grab. All rights reserved.
            </div>
          </div>
          <div className="lp-desktop-contact-core-second-row">
            <div className="lp-legal">
              <a href="https://kartaview.org/terms" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a> &nbsp;&nbsp;&nbsp;&nbsp;
              <a href="https://kartaview.org/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/desktop/Contact.js